import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useMarkNotificationRead = (
  onSuccess?: (data: any, variables: { notificationId: string }) => void,
  onError?: (error: any, variables: { notificationId: string }) => void
) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ notificationId }: { notificationId: string }) => {
      const baseUrl = t("calling-pipeline-notifications");
      const response = await axios.post(`${baseUrl}/${notificationId}/read`);
      return response.data;
    },
    onSuccess: (data, variables) => {
      if (onSuccess) onSuccess(data, variables);
    },
    onError: (error, variables) => {
      if (onError) onError(error, variables);
    }
  });
};


